<table class="table-primary">
    <thead>
    <tr>
      <th class="text-left location" scope="col">
        Location
      </th>
      <th class="text-left status" scope="col">
        Status
      </th>
      <th class="text-right controls" scope="col">
        <!-- Controls -->
      </th>
    </tr>
    </thead>
    <tbody>
    <tr class="table-row"
        *ngFor="let rowData of inventoryLocationList"
    >
      <td class="text-left location" scope="row">
        {{rowData?.name}}
        <div class="description">
            {{rowData?.description}}
        </div>
      </td>
      <td class="text-left activity">
        <app-badge *ngIf="rowData.status === InventoryLocationStatusEnum.Active"
                   [color]="BadgeColorsEnum.Green">
          Active
        </app-badge>
        <app-badge *ngIf="rowData.status === InventoryLocationStatusEnum.Inactive"
                   [color]="BadgeColorsEnum.Default">
          Inactive
        </app-badge>
      </td>
      <td class="text-right controls">
        <button *ngIf="rowData?.type === InventoryLocationTypeEnum.Custom" 
                class="table-menu-btn"
                appMenu
                [placement]="'bottom-right'"
                [autoClose]="'outside'"
                [menuContent]="tableRowMenuContent"
                triggers="manual"
                #tableRowMenu="appMenu"
                (click)="tableRowMenu.toggle();$event.stopPropagation();"
        >
          <img class="menu-icon opened" *ngIf="tableRowMenu.isOpen()" src="assets/icons/icon-close-dark-gray.svg" alt="table-row-menu"/>
          <img class="menu-icon" *ngIf="!tableRowMenu.isOpen()" src="assets/icons/icon-three-dots.svg" alt="table-row-menu"/>
        </button>
        <ng-template #tableRowMenuContent>
          <div class="menu-container primary">
            <div *ngIf="rowData.status === InventoryLocationStatusEnum.Active"
                 (click)="setActivityStatus(rowData, false);tableRowMenu.close();"
                 class="menu-item"
            >
              <div class="option start">
                Make Inactive
              </div>
            </div>
            <div *ngIf="rowData.status === InventoryLocationStatusEnum.Inactive"
                 (click)="setActivityStatus(rowData, true);tableRowMenu.close();"
                 class="menu-item"
            >
              <div class="option start">
                Make Active
              </div>
            </div>
            <div (click)="editLocation.emit(rowData);tableRowMenu.close();" class="menu-item">
              <div class="option edit">
                Edit
              </div>
            </div>
            <div (click)="openRemoveLocationDialog(rowData)" class="menu-item" *ngIf="rowData?.canDelete">
              <div class="option delete">
                Delete
              </div>
            </div>
          </div>
        </ng-template>
      </td>
    </tr>
    </tbody>
  </table>
  
  <!-- CLOSE ACCOUNT DIALOG -->
  <app-warning-dialog [show]="showRemoveLocationDialog$ | async"
                      header="Are you sure you want to do this?"
                      description="After deletion you will not be able to use this location"
                      acceptBtnText="Yes, delete location"
                      (cancel)="showRemoveLocationDialog$.next(false)"
                      (next)="locationRemovalConfirmed()"
  ></app-warning-dialog>
  